import {createRoot} from "react-dom/client"
import Mousetrap from "mousetrap"
import React, {useEffect, createElement} from "react"
import {get_or_append} from "../dom_utils"

export const fullscreen_layer_id = "fullscreen_layer_container"

// the trainer uses also the the left and right keys and therefore needs to know
// when the fullscreen layer is open
// TODO: we should refactor the shortcuts of the trainer
// to not depend on the fullscreen layer
export const fullscreen_layer_is_visible = () =>
  !!get_or_append(fullscreen_layer_id).innerHTML

export const create_fullscreen_layer = (Component, props) => {
  const container = get_or_append(fullscreen_layer_id)
  const root = createRoot(container)
  const on_close = () => {
    root.unmount()
  }
  root.render(createElement(Component, {...props, on_close}))
}

const FullscreenLayer = ({on_close, children}) => {
  useEffect(() => {
    document.body.classList.add("no-scroll")
    Mousetrap.bind("esc", () => {
      on_close()
      return false
    })
    return () => {
      document.body.classList.remove("no-scroll")
      Mousetrap.unbind("esc")
    }
  })
  return (
    <div className="fullscreen-layer">
      <div className="close" onClick={on_close} />
      {children}
    </div>
  )
}

export default FullscreenLayer
